module.exports = __webpack_public_path__ + "img/black.9e31acb4.svg";